<template>
  <div
    v-if='item.category === parentCategory'
    :id="groupId + '-' + itemID"
    class="accordion-item-inner mb-4 lg:px-20"
    :class="{ 'is-active-inner': item.active }"
  >
    <dt class="accordion-item-title-inner relative">
      <button @click="toggle" class="text-left w-full flex items-center pl-2.5 lg:pl-0">        
        <span class="block icon-inner icon-chevron-inner mr-2.5 lg:mr-5 h-5 w-5 text-orange-400 leading-tight"> ></span>
        <span class="text-green-500 font-light block lg:text-lg" v-html="item.title" />        
      </button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <dd v-if="item.active" class="overflow-hidden mt-5">
        <div v-html="item.content" class="wyswyg text-gray-100 font-light"></div>          
      </dd>
    </transition>
  </div>
</template>

<script>
import accordionItemInner from '../components/accordionItemInner'

export default {
  components: {
    accordionItemInner
  },
  props: {
    groupId: {
      type: Number,
      default: 1,
    },
    parentCategory: {
      type: String,
      default: 1,
    },
    itemID: {
      type: Number,
      default: 1,
    },
    item: {
      type: Object,
      default: ()=>{},
    },
    multiple: {
      type: Boolean,
      default: ()=>{},
    },
  },
  methods: {
    toggle(event) {
      if (this.multiple) {
        this.item.active = !this.item.active;
      } else {
        this.$parent.$children.forEach((item, index) => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) {
            item.item.active = !item.item.active;
          } else {
            item.item.active = false;
          }
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>
<style scoped >
.icon-chevron-inner {  
  display: block;
  top: 0;
  left: -2.5rem;
  bottom: 0;
  transition: transform 0.2s ease; 
  text-align: center;
}
.is-active-inner .icon-inner {
  transform: rotate(90deg)
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}

.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
